<template>
    <div class="p-4 bg-white shadow-sm rounded-lg">
        <Alerts :_success="success" :_error="error"></Alerts>

        <form @submit.prevent="changePassword()">
            <div class="form-group">
                <h5 class="font-weight-bold">Change Password</h5>
                <p class="text-muted">Create strong password, min 8 characters alphanumeric</p>
            </div>

            <div class="form-group">
                <label for="current">Current Password</label>
                <input id="current" :type="fieldType" class="form-control" placeholder="Current password"
                       v-model="passwords.current" :disabled="wait" required>
            </div>

            <div class="form-group">
                <label for="password">New Password</label>
                <input id="password" :type="fieldType" class="form-control" placeholder="New password"
                       v-model="passwords.password" :disabled="wait" required>
            </div>

            <div class="form-group">
                <label for="confirm">Confirm Password</label>
                <input id="confirm" :type="fieldType" class="form-control" placeholder="Confirm password"
                       v-model="passwords.password_confirmation" :disabled="wait" required>
            </div>

            <div class="form-group">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="show" v-model="show">
                    <label class="custom-control-label" for="show">Show passwords</label>
                </div>
            </div>

            <div>
                <button class="btn btn-success" :disabled="wait">
                    <template v-if="wait">Please wait...</template>
                    <template v-else>Change Password</template>
                </button>
            </div>
        </form>

    </div>
</template>

<script>
import Alerts from "@/components/Alerts";

export default {
    name: "Password",
    components: {Alerts},
    data() {
        return {
            show: false,
            fieldType: 'password',

            passwords: {
                current: '',
                password: '',
                password_confirmation: ''
            }
        }
    },
    methods: {
        changePassword() {
            this.clear()
            this.wait = true
            this.$http.post('password/change', this.passwords).then(() => {
                this.success = "Password changed successfully"
                setTimeout(() => (window.location.href = '/home'), 500)
            }).catch(error => {
                this.error = error.response.data.data
            }).then(() => {
                window.scroll(0, 0)
                this.wait = false
            })
        }
    },
    watch: {
        show(value) {
            (value === true) ? this.fieldType = 'text' : this.fieldType = 'password'
        }
    }
}
</script>

<style scoped>

</style>